import { gql } from '@apollo/client';
import { t } from '@lingui/macro';

export type ProviderRegisterCityResponse = {
  providerLandingPageDataByCity: {
    id: string;
    name: string;
    requestCountSinceLastWeek: number;
    seo?: {
      metaTitle: string;
      metaDescription: string;
    };
  };
};

export const providerRegisterCityQuery = gql`
  query ProviderRegisterCity($city: String!) {
    providerLandingPageDataByCity(slug: $city) {
      id
      name
      requestCountSinceLastWeek
      seo {
        metaTitle
        metaDescription
      }
    }
  }
`;

export const getTitle = (city: string): string => {
  return `${t`Zlecenia`} ${city}`;
};
